import { createEntityAdapter } from "@reduxjs/toolkit";

const okrSavedViewAdapter = createEntityAdapter()
export const {
    selectById: selectOkrSavedViewById,
    selectIds: selectOkrSavedViewIds,
    selectEntities: selectOkrSavedViewEntities,
    selectAll: selectAllOkrSavedViews,
    selectTotal: selectTotalOkrSavedViews
} = okrSavedViewAdapter.getSelectors((state: any) => state.okrSavedViews)